"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceholderPrivalia = exports.PlaceholderVP = exports.Link = exports.Logo = void 0;
const Placeholder_1 = __importDefault(require("@kawaui/icons/build/icons/informative/Placeholder"));
const PlaceholderPrivalia_1 = __importDefault(require("@kawaui/icons/build/icons/informative/PlaceholderPrivalia"));
const logo_1 = __importDefault(require("@navigation/logo"));
const styled_components_1 = __importDefault(require("styled-components"));
const link_1 = __importDefault(require("../link"));
const styles_1 = require("../skeleton/styles");
exports.Logo = (0, styled_components_1.default)(logo_1.default) `
  width: 100%;
  max-width: 230px;
  height: 30px;
  max-height: 30px;
  margin: 0 auto;

  transition: all 100ms ease-in-out;

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    width: 100%;
    height: 50px;
    max-height: 50px;
  }
`;
exports.Link = (0, styled_components_1.default)(link_1.default) `
  margin: auto;

  text-align: center;
`;
exports.PlaceholderVP = (0, styled_components_1.default)(Placeholder_1.default) `
  ${styles_1.skeletonAnimation}
`;
exports.PlaceholderPrivalia = (0, styled_components_1.default)(PlaceholderPrivalia_1.default) `
  ${styles_1.skeletonAnimation}
`;
